import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useParams } from "react-router-dom";
import DriverDetails from "./DriverDetails";
import FilterTable from "../../Common/Component/FilterTable";
import SearchTable from "../../Common/Component/SearchTable";
import DriverTrips from "./DriverTrips";
import DriverWallet from "./DriverWallet";
import DriverDocuments from "./DriverDocuments";
import SharedDataContext from "../../../_helper/SharedData";
import DriverRechargeTransactions from "./DriverRechargeTransactions";
import DriverCollectableAmount from "./DriverCollectableAmount";
import moment from "moment";
import { formatDateTime, showAlert } from "../../../Services/Shared.service";
import { getDriverCollectionAmounts } from "../../../Services/Driver.service";
import DriverSFEEDetails from "./DriverSFEEDeatils";
import DriverAttendance from "./DriverAttendance";
const DriverInfo = () => {
  const { setShowApiLoader, globalCityField, cityData, dateFilter } =
    useContext(SharedDataContext);
  const [driverList, setdriverList] = useState("Trips");
  const { driverId } = useParams();
  const [collectionsData, setCollectionsData] = useState([])
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [loader, setLoader] = useState(false)
  const [totalCollectableAmount, setTotalCollectableAmount] = useState("")
  const [totalCommissionAmount, setTotalComissionAmount] = useState("")
  const localFromDate = moment(dateFilter.startDate).set({ h: 0, m: 0, s: 0, ms: 0 });
  const localToDate = moment(dateFilter.endDate).set({ h: 23, m: 59, s: 59, ms: 999 });
  const FormatFromDate = formatDateTime(
    localFromDate,
    "YYYY-MM-DD"
  );
  const FormatToDate = formatDateTime(localToDate, "YYYY-MM-DD");
  const firstUpdate = useRef(true);


  const onChangePage = (page) => {
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const fetchDriverCollections = () => {
    setLoader(true)
    const obj = {
      driverId: Number(driverId),
      page: pagination.toString(),
      size: rowsPerPage.toString(),
      fromDate: FormatFromDate,
      toDate: FormatToDate,
    };

    getDriverCollectionAmounts(obj)
      .then((result) => {
        setLoader(false)
        if (result.data) {
          const processData = result.data.driverTripList.map((element, index) => {
            return {
              MegaCabsBookingNo: element.MegaCabsBookingNo
                ? element.MegaCabsBookingNo
                : "-",
              DriverCollectedAmount:
                element.DriverCollectedAmount
                  ? element.DriverCollectedAmount
                  : "-",
              Commission: element.Commission
                ? element.Commission
                : "-",
              TripEndTime: element.TripEndTime
                ? moment(new Date(element.TripEndTime)).format("MMM DD HH:mm")
                : "-",
            };
          });
          setCollectionsData(processData);
          setPaginationTotalRows(result.data.count);
          setTotalCollectableAmount(result.data.driverCollectableAmountTotal ? result.data.driverCollectableAmountTotal : "")
          setTotalComissionAmount(result.data.driverCommissionTotal ? result.data.driverCommissionTotal : "")
        }
      })
      .catch((err) => {
        setLoader(false)
        showAlert("error", "Something went wrong");
      });
  };

  useEffect(() => {
    fetchDriverCollections();
  }, [pagination, rowsPerPage]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    fetchDriverCollections();
  }, [dateFilter.startDate, dateFilter.endDate])
  return (
    <Fragment>
      <Container fluid={true}>
        <Col xs="12" className="padding-30">
          <DriverDetails
            driverId={driverId}
            setShowApiLoader={setShowApiLoader}
            globalCityField={globalCityField}
            cityData={cityData}
            totalCollectableAmount={totalCollectableAmount}
            fetchDriverCollections={fetchDriverCollections}
            totalCommissionAmount={totalCommissionAmount}
          />
        </Col>
        <Col md="12" className="driver-list-details">
          <div>
            {driverList == 'Trips' ? <FilterTable /> : ''}
          </div>
          <div>
            <Row className="trip-options">
              <div>
                <ul className="booking-tabs">
                  <li
                    className={`${driverList == "Trips" ? "active" : ""}`}
                    onClick={() => setdriverList("Trips")}
                  >
                    Trips
                    <div className="arrow-down"></div>
                  </li>
                  <li
                    className={`${driverList == "Wallet" ? "active" : ""}`}
                    onClick={() => setdriverList("Wallet")}
                  >
                    Wallet
                    <div className="arrow-down"></div>
                  </li>
                  <li className={`${driverList == 'Recharges' ? 'active' : ''}`} onClick={() => setdriverList('Recharges')}>
                    Recharges
                    <div className="arrow-down"></div>
                  </li>
                  <li className={`${driverList == 'Documents' ? 'active' : ''}`} onClick={() => setdriverList('Documents')}>
                    Documents
                    <div className="arrow-down"></div>
                  </li>
                  <li className={`${driverList == 'Collectable Amount' ? 'active' : ''}`} onClick={() => setdriverList('Collectable Amount')}>
                    Collectable Amount
                    <div className="arrow-down"></div>
                  </li>
                  <li className={`${driverList == 'Subscription Fees' ? 'active' : ''}`} onClick={() => setdriverList('Subscription Fees')}>
                    Subscription Fees
                    <div className="arrow-down"></div>
                  </li>
                  <li className={`${driverList == 'Attendance' ? 'active' : ''}`} onClick={() => setdriverList('Attendance')}>
                     Attendance
                    <div className="arrow-down"></div>
                  </li>
                </ul>
              </div>
            </Row>
          </div>
          <div className="search-table">
            {driverList == 'Trips' ? <SearchTable /> : ""}
          </div>
        </Col>
        <Col className="driver-list-data">
          {driverList == "Trips" ? <DriverTrips driverId={driverId} /> : ""}
          {driverList == "Wallet" ? <DriverWallet driverId={driverId} /> : ""}
          {driverList == 'Documents' ? <DriverDocuments driverId={driverId} /> : ''}
          {driverList == 'Recharges' ? <DriverRechargeTransactions driverId={driverId} /> : ''}
          {driverList == 'Collectable Amount' ? <DriverCollectableAmount collectionsData={collectionsData} onChangePage={onChangePage} onChangeRowsPerPage={onChangeRowsPerPage} rowsPerPage={rowsPerPage} paginationTotalRows={paginationTotalRows} loader={loader} /> : ''}
          {driverList == 'Subscription Fees' ? <DriverSFEEDetails driverId={driverId} /> : ''}
          {driverList == 'Attendance' ? <DriverAttendance driverId={driverId} /> : ''}
        </Col>
      </Container>
    </Fragment>
  );
};

export default DriverInfo;
